import React, { useEffect, useState, createElement } from 'react';
import { SplashScreen } from './components/SplashScreen';
import { Header } from './components/Header';
import { WhatsAppSection } from './components/WhatsAppSection';
import { AngusSection } from './components/AngusSection';
import { SlideShowSection } from './components/SlideShowSection';
import { MenuSection } from './components/MenuSection';
import { LocationSection } from './components/LocationSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  const [showSplash, setShowSplash] = useState(true);
  useEffect(() => {
    // Load Google Fonts
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Pirata+One&family=Inter:wght@400;500;700&display=swap';
    document.head.appendChild(link);
    // Hide splash screen after 4 seconds
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);
  if (showSplash) {
    return <SplashScreen onComplete={() => setShowSplash(false)} data-id="element-0" />;
  }
  return <div className="flex flex-col min-h-screen bg-pirate-black text-white" data-id="element-1">
      <Header data-id="element-2" />
      <main className="flex-grow" data-id="element-3">
        <AngusSection data-id="element-4" />
        <SlideShowSection data-id="element-5" />
        <MenuSection data-id="element-6" />
        <WhatsAppSection data-id="element-7" />
        <LocationSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
      <WhatsAppButton data-id="element-10" />
    </div>;
}